// extracted by mini-css-extract-plugin
export var category = "-BGWt";
export var container = "o2eq9";
export var image = "jHWlL";
export var textSection = "Sqtq7";
export var title = "gxneL";